










































import $ from 'jquery';
import { Component, Vue } from 'vue-property-decorator';
import ToolItemNav from '@/components/common/ToolItemNav.vue';
import ToolBox from '@/components/common/ToolBox.vue';
import APPInfo from '@/components/designer/APPInfo.vue';
import APPScope from '@/components/designer/APPScope.vue';
import ProductScope from '@/components/designer/ProductScope.vue';
import DrawScope from '@/components/designer/DrawScope.vue';
import MDPropertyGrid from '@/components/designer/MDPropertyGrid.vue';
import MDExplorer from '@/components/designer/MDExplorer.vue';
import ToolBall from '@/components/designer/ToolBall.vue';
import MultiDoc from '@/components/designer/MultiDoc.vue';
import MessageScope from '@/components/designer/MessageScope.vue';
import MessageScopeTool from '@/components/designer/MessageScopeTool.vue';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';

@Component({
  components: {
    ToolItemNav,
    ToolBox,
    APPInfo,
    APPScope,
    ProductScope,
    DrawScope,
    MDPropertyGrid,
    MDExplorer,
    MultiDoc,
    ToolBall,
    MessageScope,
    MessageScopeTool
  }
})
export default class Board extends Vue {
  created() {
    // 挂载事件
    EventBus.$on('messageScope:command', (command: string, param: boolean) => {
      if (command === 'expend') {
        const isExpend = param as boolean;
        if (isExpend) {
          document.getElementById('messageScope').style.height = '200px';
          $('.drawPanel .el-tabs--border-card > .el-tabs__content').height(document.body.clientHeight - 315);
        } else {
          document.getElementById('messageScope').style.height = '40px';
          $('.drawPanel .el-tabs--border-card > .el-tabs__content').height(document.body.clientHeight - 315 + 160);
        }
      }
    });
  }

  showLeftScope = true;
  leftScopeName = 'apps';
  showRightScope = true;
  rightScopeName = 'property';

  get curDesignId(): string {
    return this.$store.state.ModuleMD.curMDDesignId;
  }

  get curName(): string {
    const element = this.$store.state.ModuleMD.curMDElement;
    if (element && element != null) {
      return element.displayName;
    }
    return '';
  }

  leftToolItemClick(name: string) {
    if (this.showLeftScope && this.leftScopeName === name) {
      this.showLeftScope = false;
    } else {
      this.showLeftScope = true;
    }
    this.leftScopeName = name;
  }

  openPage(page: string, displayName: string) {
    if (IDEContext.instance.curUser === null) {
      this.leftToolItemClick('account');
    } else {
      EventBus.$emit('openPage', `views/pages/${page}.vue`, page, displayName, null);
    }
  }

  rightToolItemClick(name: string) {
    if (this.showRightScope && this.rightScopeName === name) {
      this.showRightScope = false;
    } else {
      this.showRightScope = true;
    }
    this.rightScopeName = name;
  }
}
